{
  "clubId": "club-user",
  "operation": null,
  "schedule": null,
  "completionMatchdayNumber": null,
  "remainingMatchdays": null
}
